import React from 'react';
import { Anchor } from 'antd';
import { getWithoutSpaces } from 'common/helpers/format.helper';
import { useAppSelector } from 'app/store/store.hooks';
import { ANCHOR_TOP_OFFSET } from 'entities/Menu/Menu.const';

export const CategoriesPanel: React.FC = () => {
  const { menuCollection } = useAppSelector((state) => state.menu);
  const categories = menuCollection?.categoriesToAsset;

  if (!categories?.length) {
    return null;
  }

  const handleAnchorAction = (href: string) => {
    const formattedName = href.replace(/#/g, '');

    if (!formattedName) {
      return;
    }

    const wrapper = document.getElementsByClassName('anchor')[0];

    if (wrapper) {
      const link = wrapper.querySelector(`a[href="#${formattedName}"]`);

      if (link) {
        const leftPadding = 24;
        // Measure against the centered .ant-anchor content box, not the full-bleed wrapper:
        // wrapper-based math added the desktop centering gap to scrollLeft and dragged the
        // bar left, out of line with the search column. Box and pills scroll together, so
        // their rect difference is the pill's flow offset regardless of current scroll.
        const box = wrapper.querySelector('.ant-anchor') ?? wrapper;
        const leftItemOffset = link.getBoundingClientRect().left - box.getBoundingClientRect().left;

        wrapper.scrollLeft = Math.max(0, leftItemOffset - leftPadding);
      }
    }
  };

  const items = categories.map(({ name, id }) => ({
    key: String(id),
    href: `#${getWithoutSpaces(name)}`,
    title: name,
  }));

  return (
    <div className="store-panel">
      <Anchor
        targetOffset={ANCHOR_TOP_OFFSET}
        classNames={{ root: 'anchor', item: 'anchor__link' }}
        onChange={handleAnchorAction}
        items={items}
      />
    </div>
  );
};
